import React from 'react';

export default class UploadMedia extends React.Component {
    constructor() {
        super();
        this.handleMaskChange = this.handleMaskChange.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }


    handleChange() {
        const files = this.refs.file.files;
        let formData = new FormData();

        if (files.length > 0) {
            formData.append('image', files[0]);
            // pass form to HOC
            this.props.onFileChange(formData);
        }
    }

    handleMaskChange() {
        this.refs.file.click();
    }

    render() {
        return (
        <div style={this.props.style}>
            <input type="file"
                   className="client__upload-input"
                   name="client-upload"
                   id="client-upload"
                   ref="file"
                   onChange={this.handleChange}
            />
            <label htmlFor="client-upload">
            </label>
        </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/_app/react-components/MediaUploader/components/UploadMedia.jsx